import Component from '../Component';
import ItemList from '../utils/ItemList';
/**
 * A component to wrap an IP address for display.
 * Designed to be customizable for different use cases.
 *
 * @example
 * <IPAddress ip="127.0.0.1" />
 * @example
 * <IPAddress ip={post.ipAddress()} />
 */
export default class IPAddress extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.ip = this.attrs.ip || '';
  }
  view() {
    return m("span", {
      className: "IPAddress"
    }, this.viewItems().toArray());
  }
  viewItems() {
    const items = new ItemList();
    items.add('ip', m("span", {
      className: "IPAddress-value"
    }, this.ip), 100);
    return items;
  }
}
flarum.reg.add('core', 'common/components/IPAddress', IPAddress);